import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { MatchingState } from '../../types/store';
import type { User, Match, ApiError } from '../../types/index';

const initialState: MatchingState = {
  potentialMatches: [],
  matches: [],
  currentMatch: null,
  isLoading: false,
  error: null,
};

const matchingSlice = createSlice({
  name: 'matching',
  initialState,
  reducers: {
    fetchPotentialMatchesStart: (state: MatchingState) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchPotentialMatchesSuccess: (state: MatchingState, action: PayloadAction<User[]>) => {
      state.isLoading = false;
      state.potentialMatches = action.payload;
      state.error = null;
    },
    fetchPotentialMatchesFailure: (state: MatchingState, action: PayloadAction<ApiError>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setCurrentMatch: (state: MatchingState, action: PayloadAction<User>) => {
      state.currentMatch = action.payload;
    },
    likeUser: (state: MatchingState, action: PayloadAction<string>) => {
      const userId = action.payload;
      state.potentialMatches = state.potentialMatches.filter(user => user.id !== userId);
    },
    passUser: (state: MatchingState, action: PayloadAction<string>) => {
      const userId = action.payload;
      state.potentialMatches = state.potentialMatches.filter(user => user.id !== userId);
    },
    addMatch: (state: MatchingState, action: PayloadAction<Match>) => {
      state.matches.push(action.payload);
    },
    clearCurrentMatch: (state: MatchingState) => {
      state.currentMatch = null;
    },
  },
});

export const {
  fetchPotentialMatchesStart,
  fetchPotentialMatchesSuccess,
  fetchPotentialMatchesFailure,
  setCurrentMatch,
  likeUser,
  passUser,
  addMatch,
  clearCurrentMatch,
} = matchingSlice.actions;

export default matchingSlice.reducer;